import { Controller } from '@hotwired/stimulus';

// Re-shows the Intro & News popup after a fixed interval on the *current*
// screen, without requiring the user to navigate or click. Reloads the
// `intro_news` turbo frame via its `show` action, which re-renders the popup and
// a fresh timer. Counts from when the campaign was last shown/dismissed.
export default class extends Controller {
  static values = { url: String, seconds: Number };

  connect() {
    if (this.secondsValue > 0) {
      this.timeout = setTimeout(() => this.reshow(), this.secondsValue * 1000);
    }
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout);
  }

  reshow() {
    const frame = document.getElementById('intro_news');
    if (frame) frame.setAttribute('src', this.urlValue);
  }
}
